<template>
  <div class="link-com">
    <!-- logo -->
    <!-- <Image src="logo" class="pc-logo" /> -->
    <tx-btn src="logo" class="logo" name="主页"/>

    <!-- 网页疑问 -->
    <rule-btn
      btn_src="oldclassic_m_home_wangyeyiwen"
      dlg_src="oldclassic_m_popoup_wangyeyiwen-di"
      title="网页疑问"
    />

    <div class="header">
      <!-- <TxBtn
        src="oldclassic_m_home_xiazaiyouxi"
        @click="openExternal(urls.download)"
      /> -->
      <TxBtn
        src="oldclassic_m_home_qianwangguanwang"
        @click="openExternal(urls.website)"
        name="前往官网"
      />
    </div>

    <TxBtn
      src="bangdan-shouqi"
      class="shouqi"
      @click="is_shouqi = !is_shouqi"
      name="更多榜单"
    />
    <TxBg
      src="oldclassic_m_home_bangdan-zhankaidiban"
      class="zhankaidiban"
      v-if="!is_shouqi"
    >
      <!-- <div class="tx3bangdan-wrapper px-24"> -->
      <div class="pl-20 pr-64 pt-40">
        <div class="link-bang">
          <TxBtn
            src="oldclassic_m_home_tx3bangdan"
            @click="openExternal(urls.tx3_rank)"
            name="天下3英雄榜"
          />
          <TxBtn
            src="oldclassic_m_home_tx2bangdan"
            @click="openExternal(urls.tx2_rank)"
            name="天下贰英雄榜"
          />
        </div>

        <div class="link-tools">
          <!-- <TxBtn
            src="oldclassic_m_home_xiazai"
            @click="openExternal(urls.download)"
          /> -->
          <div class="tx3bangdan-tools2">
            <!-- <TxBtn src="oldclassic_m_home_yancheng" @click="openExternal(urls.remote_tool)" /> -->
            <TxBtn
              src="oldclassic_m_home_yunyouxi"
              @click="openExternal(urls.yun_game)"
              name="云游戏"
            />
          </div>
        </div>
      </div>
    </TxBg>

    <TxFooter class="middle foolter-com" />
  </div>
</template>

<script setup>
const { is_mobile, urls } = inject('GlobalStore');
let is_shouqi = ref(true);

// 基础跳转方法
const openExternal = (url, newWindow = true) => {
  if (!url) return;
  if (newWindow) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = url;
  }
};
</script>

<style lang="scss" scoped>
.foolter-com {
  width: 100vw;
  padding-bottom: 24px;
}

.tx3bangdan-tools,
.tx3bangdan-tools2 {
  justify-content: center;
}

.link-bang {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.link-tools {
  width: 100%;
  height: 160px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
</style>